<template>
    <div clas="home">
      <div class="container">
        <div class="graveyard">
          <h1 class="title t-c">{{$appName}}</h1>
          <section class="grid">
            <article v-for="(v,k) in tombs" :key="k" @click="open(v.id)" class="tomb">
              <div class="epitaph">
                <span class="cross">×</span>
                <h2 class="mt-0">{{v.type}}</h2>
                <p>{{v.start}} - {{v.end}}</p>
              </div>            
            </article>
          </section>
        </div>
      </div>
      <Footer></Footer>
      <div :class="modalClass">
          <div class="modal">
              <div class="p-relative">
                  <span @click="close" class="p-absolute modal_close">×</span>
                  <div v-if="v.id === id" v-for="(v,k) in tombs" :key="k" class="modal_text t-c">
                    <h2>{{v.title}}</h2>
                    <p class="b-b pb-4">{{v.start}} - {{v.end}}</p>
                    <p class="mb-4 ">{{v.text}}</p>
                    <a :href="v.url" class="btn btn-secondary btn-block" target="_blank">Link</a>
                  </div>
              </div>
          </div>
          <div class="modal_bg"></div>
      </div>
    </div>
</template>

<script>
import Footer from "@/components/modules/footer.vue";
import {tombs} from "@/components/data/tombs.js"

export default {
  name: "Home",
  components: {
    Footer
  },
  data: function () {
    return {
      tombs: tombs,
      modalClass: '',
      id: '',
      numberDice: null
    }
  },
  methods: {
        open (id) {
            this.modalClass = 'openedModal'
            this.id = id
        },
        close() {
            this.$emit('close')
            this.modalClass = ''
            this.id = ''
        }
    }
};
</script>
